import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { NoFilterResults } from "../../../../components/Filter/NoFilterResults/NoFilterResults";
import { useArchiveFilter } from "../../../../hooks/filters/useArchiveFilter";
import { ArchiveContext } from "../../../../providers/ArchiveContextProvider";
import { ArchiveItem } from "../ArchiveItem/ArchiveItem";
function ArchiveItems() {
    var _a;
    const { state: { archivedTasks = [] }, } = useContext(ArchiveContext);
    const { filterArchive } = useArchiveFilter();
    const filteredArchiveItems = (_a = archivedTasks === null || archivedTasks === void 0 ? void 0 : archivedTasks.filter(filterArchive)) !== null && _a !== void 0 ? _a : [];
    if (archivedTasks && archivedTasks.length === 0) {
        return _jsx(NoFilterResults, { text: __("No tasks archived", "quicktasker") });
    }
    if (filteredArchiveItems && filteredArchiveItems.length === 0) {
        return _jsx(NoFilterResults, {});
    }
    return (_jsx("div", { children: _jsx("div", { className: "wpqt-card-grid", children: filteredArchiveItems.map((task) => (_jsx(ArchiveItem, { task: task }, task.id))) }) }));
}
export { ArchiveItems };
